const contact = 'contato@agilodonto.com.br';

export const legalPt = {
  privacy: {
    title: 'Política de Privacidade',
    updated: 'Atualizada em 28 de setembro de 2026.',
    sections: [
      {
        heading: 'Quem somos',
        paragraphs: [
          'A ÁgilOdonto oferece um sistema de agenda e operação para consultórios e clínicas odontológicas, disponível em agilodonto.com.br.',
          `Para assuntos desta política, escreva para ${contact}.`
        ]
      },
      {
        heading: 'Quem decide sobre os dados',
        paragraphs: [
          'Nos dados da sua conta, da cobrança e das mensagens enviadas pelo site, a ÁgilOdonto é a controladora.',
          'Nos dados de pacientes que a clínica registra no sistema - agenda, cadastro, odontograma, anotações e arquivos - a clínica é a controladora. A ÁgilOdonto trata esses dados como operadora, para prestar o serviço contratado pela clínica.'
        ]
      },
      {
        heading: 'Quais dados tratamos',
        paragraphs: [
          'Conta e equipe: nome, e-mail, senha, perfil de acesso e vínculo com a clínica. A senha fica no provedor de autenticação e não é lida por nós em texto puro.',
          'Clínica: dados cadastrais, CNPJ quando informado, horários de atendimento e convites de equipe.',
          'Pacientes, quando a clínica os inclui: nome, telefone, e-mail, CPF, data de nascimento, endereço, número de carteirinha, observações, odontograma, anexos e agendamentos.',
          'Contato pelo site: nome e WhatsApp enviados no formulário.',
          'Cobrança: plano, ciclo e status da assinatura. Pagamentos com cartão passam pelo Stripe e pagamentos por PIX pelo OpenPix. Não guardamos o número completo do cartão.',
          'Uso do produto: eventos de navegação e de uso, como login e páginas visitadas, por meio do Firebase Analytics.'
        ]
      },
      {
        heading: 'Para que usamos',
        paragraphs: [
          'Para criar e proteger a conta, operar a agenda, enviar lembretes e links de confirmação, cobrar a assinatura, responder o contato do site e manter o serviço estável.',
          'Também usamos dados agregados de uso para entender falhas e melhorar o produto. Não vendemos dados pessoais.'
        ]
      },
      {
        heading: 'Com quem compartilhamos',
        paragraphs: [
          'Google Firebase, para autenticação, banco de dados, hospedagem e analytics.',
          'Stripe e OpenPix, quando a clínica paga a assinatura.',
          'Provedor de e-mail, para mensagens da conta, como convite e redefinição de senha.',
          'Canal de lembrete configurado pela clínica, como WhatsApp, apenas com os dados necessários para o aviso da consulta.',
          'Autoridades, quando uma obrigação legal exigir.'
        ]
      },
      {
        heading: 'Por quanto tempo',
        paragraphs: [
          'Mantemos os dados enquanto a conta da clínica existir e pelo prazo exigido por lei. A clínica pode excluir pacientes e registros no próprio sistema.',
          'Depois do encerramento da conta, apagamos ou anonimizamos o que não precisamos guardar por obrigação legal.'
        ]
      },
      {
        heading: 'Seus direitos',
        paragraphs: [
          'Você pode pedir confirmação de tratamento, acesso, correção, anonimização, portabilidade, eliminação e informação sobre com quem os dados são compartilhados, além de revogar um consentimento.',
          `Pedidos sobre a conta ou sobre esta política: ${contact}. Pedidos de um paciente sobre o prontuário ou a agenda devem ser feitos à clínica, que é quem decide sobre esses dados.`
        ]
      },
      {
        heading: 'Segurança',
        paragraphs: [
          'O acesso ao sistema é por perfil, e os dados de uma clínica não ficam disponíveis para outra. A conexão com o serviço é criptografada.',
          'Nenhum ambiente elimina todo risco. A clínica deve cuidar das senhas da equipe e do que registra sobre os pacientes.'
        ]
      },
      {
        heading: 'Crianças e adolescentes',
        paragraphs: [
          'O produto é contratado por clínicas. Se a clínica registrar um paciente menor de idade, cabe a ela a base legal e o cuidado com esse dado.'
        ]
      },
      {
        heading: 'Atualizações',
        paragraphs: [
          'Quando esta política mudar, a data no topo da página é atualizada. O uso contínuo do serviço depois da mudança vale como ciência da nova versão.'
        ]
      }
    ]
  },
  terms: {
    title: 'Termos de Uso',
    updated: 'Atualizados em 28 de setembro de 2026.',
    sections: [
      {
        heading: 'Aceite',
        paragraphs: [
          'Estes termos valem para quem cria uma conta ou usa a ÁgilOdonto. Se você usa o sistema em nome de uma clínica, confirma que pode aceitá-los por ela.'
        ]
      },
      {
        heading: 'O serviço',
        paragraphs: [
          'A ÁgilOdonto organiza agenda, pacientes, equipe e confirmação de consultas. Ela não faz diagnóstico, não indica tratamento e não substitui o julgamento do dentista.',
          'O que a clínica registra no sistema é de responsabilidade da clínica, inclusive prontuário, anexos e mensagens enviadas aos pacientes.'
        ]
      },
      {
        heading: 'Conta e equipe',
        paragraphs: [
          'A clínica guarda as credenciais de acesso e responde pelos usuários que convida. Cada pessoa deve usar o próprio acesso.',
          'Perfis de administrador, secretaria e profissional enxergam apenas o que a permissão da clínica permite.'
        ]
      },
      {
        heading: 'Dados de pacientes',
        paragraphs: [
          'A clínica só deve incluir dados de pacientes quando tiver base legal para isso, e deve informar o paciente sobre o uso do sistema quando a lei exigir.',
          'A ÁgilOdonto trata esses dados para executar o serviço, nos limites da Política de Privacidade.'
        ]
      },
      {
        heading: 'Planos e pagamento',
        paragraphs: [
          'Há um teste gratuito de 20 dias, sem cobrança e sem cartão. Depois disso, a assinatura é por clínica, no ciclo mensal ou anual escolhido.',
          'Cartão é processado pelo Stripe e PIX pelo OpenPix. A falta de pagamento pode suspender o acesso até a regularização.',
          'O cancelamento encerra a renovação. O período já pago não é reembolsado, salvo quando a lei do consumidor exigir.'
        ]
      },
      {
        heading: 'Uso aceitável',
        paragraphs: [
          'É proibido usar o serviço para fim ilícito, tentar acessar dados de outra clínica, interferir na segurança da plataforma ou sobrecarregar a infraestrutura de forma abusiva.',
          'Podemos suspender uma conta que viole estes termos, com aviso quando isso for possível.'
        ]
      },
      {
        heading: 'Propriedade',
        paragraphs: [
          'O software, a marca e a interface pertencem à ÁgilOdonto. Os dados que a clínica insere continuam da clínica.'
        ]
      },
      {
        heading: 'Disponibilidade',
        paragraphs: [
          'Trabalhamos para manter o serviço no ar, com interrupções possíveis para manutenção, falha de provedor ou caso fortuito. Não há um nível de disponibilidade garantido além do esforço razoável de operação.'
        ]
      },
      {
        heading: 'Responsabilidade',
        paragraphs: [
          'Na medida permitida pela lei, a responsabilidade da ÁgilOdonto por danos diretos fica limitada ao valor pago pela clínica nos 12 meses anteriores ao fato.',
          'Essa limitação não afasta dolo, culpa grave nem direitos do consumidor que não possam ser afastados.'
        ]
      },
      {
        heading: 'Encerramento',
        paragraphs: [
          'A clínica pode encerrar a conta a qualquer momento. Podemos encerrar o serviço de uma conta inativa ou que viole estes termos.',
          'Depois do encerramento, os dados seguem a Política de Privacidade.'
        ]
      },
      {
        heading: 'Lei e contato',
        paragraphs: [
          'Estes termos seguem as leis do Brasil. Conflitos podem ser levados ao foro da comarca do domicílio do consumidor, quando essa regra se aplicar.',
          `Dúvidas: ${contact}.`
        ]
      }
    ]
  }
};

export const legalEn = {
  privacy: {
    title: 'Privacy Policy',
    updated: 'Updated on September 28, 2026.',
    sections: [
      {
        heading: 'Who we are',
        paragraphs: [
          'ÁgilOdonto provides scheduling and operations software for dental practices, available at agilodonto.com.br.',
          `Questions about this policy: ${contact}.`
        ]
      },
      {
        heading: 'Who decides about the data',
        paragraphs: [
          'For account, billing and website contact data, ÁgilOdonto is the controller.',
          'For patient data the clinic enters - schedule, chart, odontogram, notes and files - the clinic is the controller. ÁgilOdonto processes that data as an operator, to deliver the service the clinic hired.'
        ]
      },
      {
        heading: 'What we process',
        paragraphs: [
          'Account and team: name, email, password, access role and clinic link. The password stays with the authentication provider and is not read by us in plain text.',
          'Clinic: registration details, tax id when provided, working hours and team invites.',
          'Patients, when the clinic adds them: name, phone, email, tax id, date of birth, address, insurance card number, notes, odontogram, attachments and appointments.',
          'Website contact: name and WhatsApp sent through the form.',
          'Billing: plan, cycle and subscription status. Card payments go through Stripe and PIX payments through OpenPix. We do not store the full card number.',
          'Product use: navigation and usage events, such as login and pages viewed, through Firebase Analytics.'
        ]
      },
      {
        heading: 'Why we use it',
        paragraphs: [
          'To create and protect the account, run the schedule, send reminders and confirmation links, charge the subscription, answer website messages and keep the service stable.',
          'We also use aggregated usage data to understand failures and improve the product. We do not sell personal data.'
        ]
      },
      {
        heading: 'Who we share it with',
        paragraphs: [
          'Google Firebase, for authentication, database, hosting and analytics.',
          'Stripe and OpenPix, when the clinic pays for the subscription.',
          'Email provider, for account messages such as invites and password resets.',
          'The reminder channel the clinic configures, such as WhatsApp, with only the data needed for the appointment notice.',
          'Authorities, when the law requires it.'
        ]
      },
      {
        heading: 'How long',
        paragraphs: [
          'We keep data while the clinic account exists and for as long as the law requires. The clinic can delete patients and records in the product.',
          'After the account ends, we delete or anonymize what we do not have to keep by law.'
        ]
      },
      {
        heading: 'Your rights',
        paragraphs: [
          'You can ask for confirmation of processing, access, correction, anonymization, portability, deletion and information about sharing, and you can withdraw consent.',
          `Requests about the account or this policy: ${contact}. A patient asking about their chart or appointments should contact the clinic, which decides about that data.`
        ]
      },
      {
        heading: 'Security',
        paragraphs: [
          'Access follows the user role, and one clinic cannot see another clinic’s data. The connection to the service is encrypted.',
          'No environment removes every risk. The clinic should protect team passwords and what it records about patients.'
        ]
      },
      {
        heading: 'Children',
        paragraphs: [
          'The product is hired by clinics. If a clinic records a minor, the clinic is responsible for the legal basis and for that data.'
        ]
      },
      {
        heading: 'Updates',
        paragraphs: [
          'When this policy changes, the date at the top of the page changes with it. Continuing to use the service after a change means you have seen the new version.'
        ]
      }
    ]
  },
  terms: {
    title: 'Terms of Use',
    updated: 'Updated on September 28, 2026.',
    sections: [
      {
        heading: 'Acceptance',
        paragraphs: [
          'These terms apply to anyone who creates an account or uses ÁgilOdonto. If you use the system for a clinic, you confirm that you can accept them on its behalf.'
        ]
      },
      {
        heading: 'The service',
        paragraphs: [
          'ÁgilOdonto organizes the schedule, patients, team and appointment confirmation. It does not diagnose, recommend treatment or replace the dentist’s judgment.',
          'What the clinic records is the clinic’s responsibility, including charts, files and messages sent to patients.'
        ]
      },
      {
        heading: 'Account and team',
        paragraphs: [
          'The clinic keeps the access credentials and is responsible for the users it invites. Each person should use their own access.',
          'Admin, secretary and professional roles see only what that clinic’s permissions allow.'
        ]
      },
      {
        heading: 'Patient data',
        paragraphs: [
          'The clinic should enter patient data only when it has a legal basis, and should tell the patient about the system when the law requires it.',
          'ÁgilOdonto processes that data to run the service, as described in the Privacy Policy.'
        ]
      },
      {
        heading: 'Plans and payment',
        paragraphs: [
          'There is a 20-day free trial, with no charge and no card. After that, the subscription is per clinic, on the monthly or annual cycle you choose.',
          'Cards are processed by Stripe and PIX by OpenPix. Missed payment can suspend access until the account is current.',
          'Cancellation stops renewal. A period already paid is not refunded, except where consumer law requires it.'
        ]
      },
      {
        heading: 'Acceptable use',
        paragraphs: [
          'You may not use the service for anything illegal, try to access another clinic’s data, interfere with the platform’s security or overload the infrastructure.',
          'We may suspend an account that breaks these terms, with notice when that is possible.'
        ]
      },
      {
        heading: 'Ownership',
        paragraphs: [
          'The software, the brand and the interface belong to ÁgilOdonto. Data the clinic enters stays with the clinic.'
        ]
      },
      {
        heading: 'Availability',
        paragraphs: [
          'We work to keep the service online. Interruptions can happen for maintenance, a provider failure or events outside our control. There is no uptime level beyond reasonable operational effort.'
        ]
      },
      {
        heading: 'Liability',
        paragraphs: [
          'As far as the law allows, ÁgilOdonto’s liability for direct damages is limited to the amount the clinic paid in the 12 months before the event.',
          'This limit does not cover willful misconduct, gross fault or consumer rights that cannot be waived.'
        ]
      },
      {
        heading: 'Ending the account',
        paragraphs: [
          'The clinic can close the account at any time. We can close an inactive account or one that breaks these terms.',
          'After closure, data follows the Privacy Policy.'
        ]
      },
      {
        heading: 'Law and contact',
        paragraphs: [
          'These terms follow the laws of Brazil. Disputes can go to the court of the consumer’s home city when that rule applies.',
          `Questions: ${contact}.`
        ]
      }
    ]
  }
};

export const legalEs = {
  privacy: {
    title: 'Política de Privacidad',
    updated: 'Actualizada el 28 de septiembre de 2026.',
    sections: [
      {
        heading: 'Quiénes somos',
        paragraphs: [
          'ÁgilOdonto ofrece un sistema de agenda y operación para consultorios y clínicas odontológicas, disponible en agilodonto.com.br.',
          `Para asuntos de esta política, escriba a ${contact}.`
        ]
      },
      {
        heading: 'Quién decide sobre los datos',
        paragraphs: [
          'En los datos de la cuenta, del cobro y del contacto por el sitio, ÁgilOdonto es la responsable.',
          'En los datos de pacientes que la clínica registra - agenda, ficha, odontograma, notas y archivos - la clínica es la responsable. ÁgilOdonto los trata como operadora, para prestar el servicio contratado.'
        ]
      },
      {
        heading: 'Qué datos tratamos',
        paragraphs: [
          'Cuenta y equipo: nombre, correo, contraseña, perfil de acceso y vínculo con la clínica. La contraseña queda en el proveedor de autenticación y no la leemos en texto plano.',
          'Clínica: datos de registro, identificación fiscal cuando se informa, horarios e invitaciones del equipo.',
          'Pacientes, cuando la clínica los incluye: nombre, teléfono, correo, identificación fiscal, fecha de nacimiento, dirección, número de carné, observaciones, odontograma, archivos y citas.',
          'Contacto del sitio: nombre y WhatsApp enviados en el formulario.',
          'Cobro: plan, ciclo y estado de la suscripción. El pago con tarjeta pasa por Stripe y el PIX por OpenPix. No guardamos el número completo de la tarjeta.',
          'Uso del producto: eventos de navegación y de uso, como inicio de sesión y páginas visitadas, mediante Firebase Analytics.'
        ]
      },
      {
        heading: 'Para qué los usamos',
        paragraphs: [
          'Para crear y proteger la cuenta, operar la agenda, enviar recordatorios y enlaces de confirmación, cobrar la suscripción, responder el contacto del sitio y mantener el servicio estable.',
          'También usamos datos agregados de uso para entender fallas y mejorar el producto. No vendemos datos personales.'
        ]
      },
      {
        heading: 'Con quién los compartimos',
        paragraphs: [
          'Google Firebase, para autenticación, base de datos, hosting y analytics.',
          'Stripe y OpenPix, cuando la clínica paga la suscripción.',
          'Proveedor de correo, para mensajes de la cuenta, como invitación y restablecimiento de contraseña.',
          'El canal de recordatorio que configura la clínica, como WhatsApp, solo con los datos necesarios para el aviso de la cita.',
          'Autoridades, cuando la ley lo exige.'
        ]
      },
      {
        heading: 'Durante cuánto tiempo',
        paragraphs: [
          'Conservamos los datos mientras exista la cuenta de la clínica y durante el plazo que exija la ley. La clínica puede eliminar pacientes y registros en el sistema.',
          'Después del cierre de la cuenta, borramos o anonimizamos lo que no debamos conservar por obligación legal.'
        ]
      },
      {
        heading: 'Sus derechos',
        paragraphs: [
          'Puede pedir confirmación del tratamiento, acceso, corrección, anonimización, portabilidad, eliminación e información sobre con quién se comparten los datos, y revocar un consentimiento.',
          `Pedidos sobre la cuenta o esta política: ${contact}. El pedido de un paciente sobre su ficha o su agenda debe hacerse a la clínica, que es quien decide sobre esos datos.`
        ]
      },
      {
        heading: 'Seguridad',
        paragraphs: [
          'El acceso sigue el perfil del usuario, y los datos de una clínica no están disponibles para otra. La conexión con el servicio va cifrada.',
          'Ningún entorno elimina todo riesgo. La clínica debe cuidar las contraseñas del equipo y lo que registra sobre los pacientes.'
        ]
      },
      {
        heading: 'Niños y adolescentes',
        paragraphs: [
          'El producto lo contratan las clínicas. Si la clínica registra a un menor, le corresponde la base legal y el cuidado de ese dato.'
        ]
      },
      {
        heading: 'Actualizaciones',
        paragraphs: [
          'Cuando esta política cambie, se actualiza la fecha al inicio de la página. Seguir usando el servicio después del cambio significa que conoció la nueva versión.'
        ]
      }
    ]
  },
  terms: {
    title: 'Términos de Uso',
    updated: 'Actualizados el 28 de septiembre de 2026.',
    sections: [
      {
        heading: 'Aceptación',
        paragraphs: [
          'Estos términos valen para quien crea una cuenta o usa ÁgilOdonto. Si usa el sistema en nombre de una clínica, confirma que puede aceptarlos por ella.'
        ]
      },
      {
        heading: 'El servicio',
        paragraphs: [
          'ÁgilOdonto organiza agenda, pacientes, equipo y confirmación de citas. No diagnostica, no indica tratamiento y no reemplaza el criterio del dentista.',
          'Lo que la clínica registra es responsabilidad de la clínica, incluida la historia clínica, los archivos y los mensajes enviados a los pacientes.'
        ]
      },
      {
        heading: 'Cuenta y equipo',
        paragraphs: [
          'La clínica guarda las credenciales y responde por los usuarios que invita. Cada persona debe usar su propio acceso.',
          'Los perfiles de administrador, secretaría y profesional ven solo lo que permite el permiso de la clínica.'
        ]
      },
      {
        heading: 'Datos de pacientes',
        paragraphs: [
          'La clínica solo debe incluir datos de pacientes cuando tenga base legal, y debe informar al paciente sobre el uso del sistema cuando la ley lo exija.',
          'ÁgilOdonto trata esos datos para ejecutar el servicio, según la Política de Privacidad.'
        ]
      },
      {
        heading: 'Planes y pago',
        paragraphs: [
          'Hay una prueba gratuita de 20 días, sin cobro y sin tarjeta. Después, la suscripción es por clínica, en el ciclo mensual o anual elegido.',
          'La tarjeta la procesa Stripe y el PIX OpenPix. La falta de pago puede suspender el acceso hasta la regularización.',
          'La cancelación detiene la renovación. El período ya pagado no se reembolsa, salvo cuando la ley del consumidor lo exija.'
        ]
      },
      {
        heading: 'Uso aceptable',
        paragraphs: [
          'Está prohibido usar el servicio para un fin ilícito, intentar acceder a datos de otra clínica, interferir en la seguridad de la plataforma o sobrecargar la infraestructura.',
          'Podemos suspender una cuenta que viole estos términos, con aviso cuando sea posible.'
        ]
      },
      {
        heading: 'Propiedad',
        paragraphs: [
          'El software, la marca y la interfaz pertenecen a ÁgilOdonto. Los datos que ingresa la clínica siguen siendo de la clínica.'
        ]
      },
      {
        heading: 'Disponibilidad',
        paragraphs: [
          'Trabajamos para mantener el servicio en línea. Puede haber interrupciones por mantenimiento, falla de un proveedor o caso fortuito. No hay un nivel de disponibilidad garantizado más allá del esfuerzo razonable de operación.'
        ]
      },
      {
        heading: 'Responsabilidad',
        paragraphs: [
          'En la medida que permite la ley, la responsabilidad de ÁgilOdonto por daños directos se limita al valor pagado por la clínica en los 12 meses anteriores al hecho.',
          'Ese límite no cubre dolo, culpa grave ni derechos del consumidor que no se puedan renunciar.'
        ]
      },
      {
        heading: 'Cierre',
        paragraphs: [
          'La clínica puede cerrar la cuenta en cualquier momento. Podemos cerrar una cuenta inactiva o que viole estos términos.',
          'Después del cierre, los datos siguen la Política de Privacidad.'
        ]
      },
      {
        heading: 'Ley y contacto',
        paragraphs: [
          'Estos términos siguen las leyes de Brasil. Los conflictos pueden ir al fuero del domicilio del consumidor, cuando esa regla se aplique.',
          `Dudas: ${contact}.`
        ]
      }
    ]
  }
};
